import GLOBAL from './GLOBAL';

const domContentAlreadyLoaded = (doc) =>
  doc.readyState === 'complete' || doc.readyState === 'interactive';

const afterDomContentLoaded = (fn) => {
  const doc = GLOBAL.getDocument();

  if (domContentAlreadyLoaded(doc)) {
    fn();
  } else {
    doc.addEventListener('DOMContentLoaded', () => {
      fn();
    });
  }
};

export default afterDomContentLoaded;
